import {ReactComponent as HomeIcon} from './home.svg'

function Home() {
  return <HomeIcon />
}

export default Home
